import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["href", "data-testid", "target", "rel"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("a", {
    href: _ctx.url,
    class: "tw-text-xs tw-font-medium !tw-text-deep-orange-500 hover:!tw-text-deep-orange-500",
    "data-testid": _ctx.trackingId,
    target: _ctx.newTab ? '_blank' : '_self',
    rel: _ctx.newTab ? 'noopener noreferrer' : undefined,
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('click')))
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 8, _hoisted_1))
}